import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import {
  CURRENT_LANGUAGE,
  ENGLISH_EXTERNAL_CONTENT_SUFFIX,
  GERMAN_EXTERNAL_CONTENT_SUFFIX,
  GERMAN_LANGUAGE,
} from "~/utils/constants";

export function transformToExternalUrl(label: string, baseExternalUrl: string) {
  let url = baseExternalUrl + label;

  if (CURRENT_LANGUAGE.toLowerCase() === GERMAN_LANGUAGE) {
    url += GERMAN_EXTERNAL_CONTENT_SUFFIX;
  } else {
    url += ENGLISH_EXTERNAL_CONTENT_SUFFIX;
  }

  return url;
}

export function resolvePotentiallyExternalLabel(label: string, context: TransformationContext) {
  if (
    !label ||
    // Backwards compatible logic - Linear configurator contains actual texts so if it's not an url, it stays how it is
    context.configuratorType === ConfiguratorType.System ||
    // Shaft configurators use translation keys instead
    context.configuratorType === ConfiguratorType.MetricShaft ||
    context.configuratorType === ConfiguratorType.InchShaft
  ) {
    return label;
  }
  return label.toLowerCase().startsWith("http") ? label : transformToExternalUrl(label, context.baseExternalUrl);
}

export interface TransformationContext {
  productCode: string;
  configuratorType: ConfiguratorType;
  baseExternalUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  specialTranslations: Dict<any>;
}
